import { render, staticRenderFns } from "./ProjectJSONLD.vue?vue&type=template&id=70b73464&"
import script from "./ProjectJSONLD.vue?vue&type=script&lang=js&"
export * from "./ProjectJSONLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports